var map = {
	"./tb_web_stitch_base01_.png": 825108,
	"./tb_web_stitch_base01_blk.png": 830851,
	"./tb_web_stitch_base01_blu.png": 302717,
	"./tb_web_stitch_base01_cml.png": 617650,
	"./tb_web_stitch_base01_crk.png": 517096,
	"./tb_web_stitch_base01_grn.png": 920681,
	"./tb_web_stitch_base01_lgd.png": 396387,
	"./tb_web_stitch_base01_lsl.png": 274471,
	"./tb_web_stitch_base01_nvy.png": 370415,
	"./tb_web_stitch_base01_orn.png": 794577,
	"./tb_web_stitch_base01_pnk.png": 974299,
	"./tb_web_stitch_base01_ppl.png": 433770,
	"./tb_web_stitch_base01_red.png": 617927,
	"./tb_web_stitch_base01_sax.png": 808274,
	"./tb_web_stitch_base01_wht.png": 44749,
	"./tb_web_stitch_base01_ylw.png": 138820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 145801;